import config from 'SRC/config/config.json'
import { phoneValidator } from 'Core/validators'

export const prepareFields = (values, {
	authInfo: { userId, token },
	photos,
	categoryId,
	activeTab
}) => {
	const formData = new FormData()

	formData.append('category', categoryId)
	let filledSpec = []
	let swapps = []
	let equipment = []

	for(var pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}

	Object.keys(values).forEach(field => {
		if (Object.prototype.hasOwnProperty.call(values, field)) {
			switch (field) {
				case 'newUser':
				case 'existingUser':
				case 'price':
        case 'discountedPrice':
				case 'priceTypeForAddons':
        case 'typeOfPrice':
				case 'discount':
				case 'priceFrom':
				case 'priceTo':
				case 'priceOnRequest':
				case 'compatibilityCategory':
				case 'compatibilityUniversality':
				case 'compatibilities':
				case 'useTitleForCompiledTitle':
					break
				case 'equipment':
					equipment = Object.keys(values[field]).reduce((acc, curr) => {
						return acc.concat(values[field][curr])
					}, [])

					if (equipment.length) {
						formData.append(field, JSON.stringify(equipment))
					}
					break
				case 'swapps':
					if (Array.isArray(values[field])) {
						swapps = values[field].map(item => {
							const swap = {}
							if (item) {
								if (item.category && Number(item.cateogry) !== -1) {
									swap.category = item.category
								}
								if (item.brand && Number(item.brand) !== -1) {
									swap.brand = item.brand
								}
								if (item.product && Number(item.product) !== -1) {
									swap.product = item.product
								}
								if (item.specification1 && Number(item.specification1) !== -1 && item.specificationValue1) {
									swap.specification1 = item.specification1
									swap.specificationValue1 = item.specificationValue1
								}
								if (item.specification2 && Number(item.specification2) !== -1 && item.specificationValue2) {
									swap.specification2 = item.specification2
									swap.specificationValue2 = item.specificationValue2
								}
							}

							if (!Object.keys(swap).length) return {}

							// remove empty elements
							return Object.keys(swap).reduce((acc, curr) => {
								if (Number(swap[curr]) !== -1) {
									acc[curr] = swap[curr]
								}
								return acc
							}, {})
						}).filter(item => item && Object.keys(item).length)
					}

					if (swapps.length) {
						formData.append(field, JSON.stringify(swapps))
					}
					break
				case 'specifications':
					filledSpec = Array.isArray(values[field]) && values[field].filter(item => item.value && Number(item.value) !== -1)
					if (filledSpec.length) {
						formData.append(field, JSON.stringify(filledSpec.map(item => ({ id: item.id, value: item.value }))))
					}
					break
				case 'title':
					if (values[field] && Number(values[field]) !== -1) {
						formData.append(field, values[field])
					}

					if (values.useTitleForCompiledTitle && Number(values.useTitleForCompiledTitle) !== -1) {
						formData.append('useTitleForCompiledTitle', values.useTitleForCompiledTitle)
					}
					break
				default:
					if (typeof values[field] !== 'object' && values[field] && Number(values[field]) !== -1) {
						formData.append(field, values[field])
					}
					break
			}
		}
	})

	for(var pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}

	if (userId && token) {
		formData.append('token', token)
		formData.append('userId', userId)
	}

	for(var pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}

	if ((!userId || !token) && Object.prototype.hasOwnProperty.call(values, 'newUser') && activeTab === 'register') {
		const newUser = {
			phone: `${values.newUser.dial}${values.newUser.phone}`.replace('+', '').replace(/ /g, '').trim(),
			name: values.newUser.name,
			code: values.newUser.code,
			country: values.newUser.country,
			city: values.newUser.city,
			location: values.newUser.location
		}

		if (values.newUser.surname) newUser.surname = values.newUser.surname
		if (values.newUser.email) newUser.email = values.newUser.email

		formData.append('newUser', JSON.stringify(newUser))
	}

	if ((!userId || !token) && Object.prototype.hasOwnProperty.call(values, 'existingUser') && activeTab === 'auth') {
		const existingUser = {password: values.existingUser.password}

		if (values.existingUser && values.existingUser.dial && values.existingUser.phone) {
			const phoneWithDial = `${values.existingUser.dial}${values.existingUser.phone}`.replace('+', '').replace(/ /g, '').trim()

			console.log('phoneWithDial', phoneWithDial)
			if (phoneValidator(phoneWithDial)) {
				existingUser.phone = phoneWithDial
			}
		}

		formData.append('existingUser', JSON.stringify(existingUser))
	}

	for(var pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}
	/**
	 * Prices
	 */
	if (values.discountedPrice && values.price && Number(values.discountedPrice) !== -1 && Number(values.price) !== -1) {
		formData.append('price', values.discountedPrice)
		formData.append('oldPrice', values.price)
	}

	if (
		values.price && Number(values.price) !== -1 &&
		(!values.discountedPrice || Number(values.discountedPrice) === -1) &&
		(!values.priceFrom || Number(values.priceFrom) === -1) &&
		(!values.priceTo || Number(values.priceTo) === -1)
	) {
		formData.append('price', values.price)
	}

	if (values.discount && Number(values.discount) !== -1) {
		formData.append('discount', values.discount)
	}

	if (values.priceFrom && Number(values.priceFrom) !== -1) {
		formData.append('priceFrom', values.priceFrom)
	}

	if (values.priceTo && Number(values.priceTo) !== -1) {
		formData.append('priceTo', values.priceTo)
	}

	if (values.priceOnRequest && Number(values.priceOnRequest) !== -1) {
		formData.append('priceOnRequest', true)
	}

	if (values.typeOfPrice && Number(values.typeOfPrice) !== -1) {
		formData.append('typeOfPrice', values.typeOfPrice)
	}

	for(var pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}
	/**
	 * End prices
	 */
	if (!values.description) formData.append('description', null)

	if (values.compatibilityCategory) {
		const compatibilities = []

		if (!values.compatibilityUniversality && Array.isArray(values.compatibilities) && values.compatibilities.length) {
			values.compatibilities.forEach(comp => {
				const compatibility = { category: values.compatibilityCategory }
				if (comp.brand && Number(comp.brand) !== -1) compatibility.brand = Number(comp.brand)
				if (comp.product && Number(comp.product) !== -1) compatibility.product = Number(comp.product)
				if (comp.years && Number(comp.years) !== -1 && Array.isArray(comp.years) && comp.years.length) compatibility.years = comp.years
				compatibilities.push(compatibility)
			})
		} else {
			compatibilities.push({ category: values.compatibilityCategory })
		}

		formData.append('compatibilities', JSON.stringify(compatibilities))
	}

	// PHOTOS NEW
	if (Array.isArray(photos) && photos.length) {
		formData.append('uploadedImages', JSON.stringify(photos.map((photo, index) => ({
			fd: photo?.fd?.replace(config.mediaCDN, '') || '',
			main: index === 0,
			priority: index,
			visible: photo.visible
		}))))
	}

	for (let pair of formData.entries()) {
		console.log(pair[0]+ ', '+ pair[1]);
	}

	return formData
}